module.exports = "/images/dataphoneImg.svg";